import cn from "classnames";
import { getNumberStructure, isValidCarNumber, isValidTrailerNumber } from "helpers/carnumber";
import { bidStatusesEnum, featureModuleTypesEnum } from "helpers/enums";
import { hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { isOnlyInRole } from "helpers/roles";
import upperFirst from "lodash/upperFirst";
import Tooltip from "rc-tooltip";
import React, { Component } from "react";

export default class Truck extends Component {
    state = {
        openedCarDropd: false,
        openedTrailerDropd: false,
    };

    renderCarDropd = (carId) => {
        const newBidAction = () => {
            this.props.history.push(`${paths.bidNew}?carId=${carId}`);
        };
        const filterByCarAction = () => {
            this.props.history.push(`${paths.bid}?carId=${carId}`);
        };
        const { bid, modal } = this.props;
        const { car } = bid;
        const { comment, planningComment } = car || {};
        const showCarInfo = () => {
            modal({
                name: "infoModal",
                windowMod: "wide",
                title: "Ссылки на документы",
                body: <div className="modal__body">{comment}</div>,
            });
        };
        const editCommentAction = () => {
            this.props.modal({
                name: "planningCommentForm",
                title: "Редактирование комментария",
                carId,
                planningComment,
                callback: this.props.updateCarPlanningComment,
            });
        };
        const newCommentAction = () => {
            this.props.modal({
                name: "planningCommentForm",
                title: "Создание комментария",
                planningComment: "",
                carId,
                callback: this.props.updateCarPlanningComment,
            });
        };

        return (
            <ul className="c-dropd__list c-dropd__list--left c-dropd__list--wide no-bullet">
                {!this.props.organization.distributedBidRequired && (
                    <li className="c-dropd__list-item" onClick={newBidAction}>
                        Создать заявку для машины
                    </li>
                )}
                <li className="c-dropd__list-item" onClick={filterByCarAction}>
                    Открыть список заявок по машине
                </li>
                {comment && (
                    <li className="c-dropd__list-item" onClick={showCarInfo}>
                        Ссылки на документы
                    </li>
                )}
                {!planningComment && (
                    <li className="c-dropd__list-item" onClick={newCommentAction}>
                        Добавить комментарий
                    </li>
                )}
                {planningComment && (
                    <li className="c-dropd__list-item" onClick={editCommentAction}>
                        Изменить комментарий
                    </li>
                )}
            </ul>
        );
    };

    renderTrailerDropd = () => {
        const { bid, modal } = this.props;
        const { trailer } = bid;
        const { comment, trailerId } = trailer || {};
        const showTrailerInfo = () => {
            modal({
                name: "infoModal",
                windowMod: "wide",
                title: "Ссылки на документы",
                body: <div className="modal__body">{comment}</div>,
            });
        };

        return (
            <ul className="c-dropd__list c-dropd__list--left c-dropd__list--wide no-bullet">
                {comment && (
                    <li className="c-dropd__list-item" onClick={showTrailerInfo}>
                        Ссылки на документы
                    </li>
                )}
                <li
                    className="c-dropd__list-item"
                    onClick={() => this.props.history.push(`${paths.bid}?trailerId=${trailerId}`)}
                >
                    Открыть список заявок по прицепу
                </li>
            </ul>
        );
    };

    openDropd = (openedDropd) => {
        this.setState({ [openedDropd]: true });
        setTimeout(() => document.addEventListener("click", this.closeDropd), 0);
    };

    closeDropd = () => {
        this.setState({ openedCarDropd: false, openedTrailerDropd: false });
        document.removeEventListener("click", this.closeDropd);
    };

    renderIcons = () => {
        const { bid } = this.props;
        const { car } = bid;
        const { planningComment } = car || {};
        if (!planningComment) {
            return null;
        }
        return (
            <div className="d-flex overflow-hidden pt-1">
                <Tooltip overlay={planningComment} overlayClassName="planning-table__body--tooltip">
                    <i className="icon-uEA88-info-circle text-info" />
                </Tooltip>
            </div>
        );
    };

    render() {
        const { openedCarDropd, openedTrailerDropd } = this.state;
        const { bid, enums, profile, organization } = this.props;
        const { car, trailer, price, carGroups } = bid;
        const { trackerId, carId, carOutput } = car || {};
        const carNumber = getNumberStructure(car ? car.number : null);
        const trailerNumber = getNumberStructure(trailer ? trailer.number : null);
        const carBrandTypeObj = car ? enums.carBrandType.find((item) => item.value === car.brandTypeId) : null;
        const trailerTypeObj = trailer ? enums.trailerType.find((item) => item.value === trailer.typeId) : "";
        const trailerBrandTypeObj = trailer
            ? enums.trailerBrandType.find((item) => item.value === trailer.brandTypeId)
            : null;
        const trailerNumberCname = cn("carnumber__wrap", { "carnumber__wrap--noclickable": !trailer });
        const carSensorMonitoringEnabled = profile.availableFeatureModules.includes(
            featureModuleTypesEnum.CarSensorMonitoring,
        );
        const isStartBid = bidStatusesEnum.Started === bid.status;
        return (
            <>
                {car && (
                    <>
                        <div className="show-bid__main-info--title">Машина</div>
                        <div className="show-bid__main-info--value show-bid__main-info--carnumber" data-test-id="car">
                            {isValidCarNumber(car.number) ? (
                                <div className="carnumber__wrap" onClick={this.openDropd.bind(this, "openedCarDropd")}>
                                    <div className="carnumber__number">
                                        {carNumber.number.letters[0]}&nbsp;{carNumber.number.number}&nbsp;
                                        {carNumber.number.letters[1]}
                                    </div>
                                    <div className="carnumber__region">{carNumber.region}</div>
                                </div>
                            ) : (
                                <div className="carnumber__wrap">
                                    <div
                                        className="carnumber__number carnumber__number--without-region"
                                        onClick={this.openDropd.bind(this, "openedCarDropd")}
                                    >
                                        {car.number}
                                    </div>
                                </div>
                            )}
                            {openedCarDropd && this.renderCarDropd(carId)}
                            {trackerId && (
                                <Tooltip overlay="К машине привязан трекер">
                                    <div className="show-bid__section-title--tracker text-success d-inline-block">
                                        <span className="icon-uEA71-map-marked pl-2" />
                                    </div>
                                </Tooltip>
                            )}
                            {carBrandTypeObj && <span className="pl-2 text-muted">{carBrandTypeObj.label}</span>}
                            {this.renderIcons(carId)}
                            {bid.status === bidStatusesEnum.New && carOutput && (
                                <>
                                    <div data-test-id="factOutput">
                                        {upperFirst(organization?.currencyData?.name)}/км с начала месяца без учета
                                        заявки:{" "}
                                        <b>
                                            {hiddenUserData(
                                                carOutput.factOutput,
                                                { valueMask: "xx.xx" },
                                                isOnlyInRole(this.props.roles, "isTruckingOrganizationDispatcher"),
                                            )}
                                        </b>
                                    </div>
                                    {price > 0 && (
                                        <div data-test-id="planOutput">
                                            Плановый {organization?.currencyData?.name}/км с учетом заявки:{" "}
                                            <b>
                                                {hiddenUserData(
                                                    carOutput.planOutput,
                                                    { valueMask: "xx.xx" },
                                                    isOnlyInRole(this.props.roles, "isTruckingOrganizationDispatcher"),
                                                )}
                                            </b>
                                        </div>
                                    )}
                                    {!!carOutput.wantedOutput && (
                                        <>
                                            <div data-test-id="wantedOutput">
                                                Желаемый {organization?.currencyData?.name}/км:{" "}
                                                <b>
                                                    {hiddenUserData(
                                                        carOutput.wantedOutput,
                                                        { valueMask: "xx.xx" },
                                                        isOnlyInRole(
                                                            this.props.roles,
                                                            "isTruckingOrganizationDispatcher",
                                                        ),
                                                    )}
                                                </b>
                                            </div>
                                            <div data-test-id="differenceBetweenPlanAndWantedOutput">
                                                Разница между плановым и желаемым:{" "}
                                                <b>
                                                    {hiddenUserData(
                                                        carOutput.differenceBetweenPlanAndWantedOutput,
                                                        { valueMask: "xx.xx" },
                                                        isOnlyInRole(
                                                            this.props.roles,
                                                            "isTruckingOrganizationDispatcher",
                                                        ),
                                                    )}
                                                </b>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {isStartBid && carSensorMonitoringEnabled && bid.trackerSensorValue && (
                                <div data-test-id="trackerSensorValue">
                                    Текущий уровень топлива: <b>{bid.trackerSensorValue}</b>
                                </div>
                            )}
                        </div>
                    </>
                )}
                {!!carGroups?.length && (
                    <>
                        <div className="show-bid__main-info--title">Группы машины</div>
                        <div className="show-bid__main-info--value" data-test-id="car-groups">
                            <ul className="pl-3 mb-0">
                                {carGroups.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </>
                )}
                {trailer && trailer.number && (
                    <>
                        <div className="show-bid__main-info--title">Прицеп</div>
                        <div
                            className="show-bid__main-info--value show-bid__main-info--carnumber"
                            data-test-id="trailer"
                        >
                            {isValidTrailerNumber(trailer.number) ? (
                                <div
                                    className={trailerNumberCname}
                                    onClick={() => this.openDropd("openedTrailerDropd")}
                                >
                                    <div className="carnumber__number">
                                        {trailerNumber.number.letters[0]}&nbsp;{trailerNumber.number.number}
                                    </div>
                                    <div className="carnumber__region">
                                        {trailerNumber.region || <span>&nbsp;</span>}
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="carnumber__number carnumber__number--without-region"
                                    onClick={() => this.openDropd("openedTrailerDropd")}
                                >
                                    {trailer.number}
                                </div>
                            )}
                            {openedTrailerDropd && this.renderTrailerDropd()}
                            {trailerTypeObj && (
                                <span className="pl-2 text-muted" data-test-id="trailerType">
                                    {trailerTypeObj.label}
                                </span>
                            )}
                            {trailerBrandTypeObj && (
                                <span className="pl-2 text-muted" data-test-id="trailerBrandType">
                                    {trailerBrandTypeObj.label}
                                </span>
                            )}
                            {isStartBid && carSensorMonitoringEnabled && bid.trailerTrackerSensorValue && (
                                <div data-test-id="trailerTrackerSensorValue">
                                    Текущий уровень топлива: <b>{bid.trailerTrackerSensorValue}</b>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </>
        );
    }
}
